import React, { useState } from 'react';

const ExponentialTable = () => {
  const [startX, setStartX] = useState(0);
  const [endX, setEndX] = useState(10);
  const [step, setStep] = useState(1);
  const [expTable, setExpTable] = useState([]);

  // Function to generate the exponential table
  const generateExponentialTable = () => {
    if (startX >= endX) {
      alert("Start value should be less than the End value.");
      return;
    }
    
    const table = [];
    for (let x = startX; x <= endX; x += step) {
      const expValue = Math.exp(x);
      table.push({
        x,
        expValue: expValue.toFixed(4), // Rounded to 4 decimal places
      });
    }
    setExpTable(table);
  };

  return (
    <div>
      <h2>Exponential Function Table (e^x)</h2>
      <label htmlFor="startX">Start X: </label>
      <input
        type="number"
        id="startX"
        value={startX}
        onChange={(e) => setStartX(parseFloat(e.target.value))}
      />
      <br />
      <label htmlFor="endX">End X: </label>
      <input
        type="number"
        id="endX"
        value={endX}
        onChange={(e) => setEndX(parseFloat(e.target.value))}
      />
      <br />
      <label htmlFor="step">Step: </label>
      <input
        type="number"
        id="step"
        value={step}
        min="0.1"
        step="0.1"
        onChange={(e) => setStep(parseFloat(e.target.value))}
      />
      <br />
      <button onClick={generateExponentialTable}>Generate Table</button>

      {expTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>X</th>
              <th>e^X</th>
            </tr>
          </thead>
          <tbody>
            {expTable.map((row, index) => (
              <tr key={index}>
                <td>{row.x}</td>
                <td>{row.expValue}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ExponentialTable;
